import { useLocation, useNavigate } from 'react-router-dom';
import useModal from 'hooks/useModal';
import SingleBtn from 'components/common/elements/SingleBtn';
import useGoBack from 'hooks/useGoBack';
import useDeleteChart from 'hooks/chart/useDeleteChart';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from 'store/auth';

type TProps = {
  category: string;
  id: number;
  patientId: string | undefined;
  courseId: string | undefined;
  courseInfoId: string | undefined;
  chartRound: string | undefined;
  studentUserId: string | undefined;
  isRegister: boolean;
  isEdit: boolean;
  isReadOnly: boolean;
  chartName: string | undefined;
  feedbackId?: number;
  isFeedback?: boolean;
  isChart?: boolean;
};

const ChartBottomBtn = ({
  category,
  id,
  patientId,
  courseId,
  courseInfoId,
  chartRound,
  studentUserId,
  isRegister,
  isEdit,
  isReadOnly,
  chartName,
  feedbackId,
  isFeedback,
  isChart,
}: TProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { openModal } = useModal();
  const goBack = useGoBack();
  const { deleteChart } = useDeleteChart();

  const userInfo = useAtomValue(userInfoAtom);
  const isProfessor = userInfo?.userRole === 'PROFESSOR';
  const isStudent = userInfo?.userRole === 'STUDENT';

  const handleBack = () => {
    // 학생 > 제출 마감 후
    // 교수 > 피드백 조회 화면 or 피드백 작성 화면에서 변경 사항이 없는 경우 - if문 조건 추가 필요
    if ((isStudent && isReadOnly) || (isProfessor && !isFeedback)) {
      goBack({
        patientId,
        courseId,
        courseInfoId,
        chartRound,
        studentUserId,
      });
      return;
    }
    // 학생 > 제출 마감 전 차트 작성 화면
    // 교수 > 피드백 작성 화면 > 변경된 내용이 있는 경우
    if ((isStudent && !isReadOnly) || (isProfessor && isFeedback)) {
      openModal({
        isConfirm: true,
        title:
          category !== 'feedback'
            ? '차트 작성을 중단하시겠습니까?'
            : '피드백 작성 종료',
        text: `해당 페이지에서 나가면 작성 중인 내용이 저장되지 않습니다. ${
          category !== 'feedback' ? '차트' : '피드백'
        } 작성을 종료하시겠습니까?`,
        onSubmit: () =>
          goBack(
            category !== 'practice'
              ? {
                  patientId,
                  courseInfoId,
                  chartRound,
                  studentUserId,
                }
              : {}
          ),
      });
    }
  };

  return (
    <div className="chart_btn_wrapper excluded1 excluded2">
      <SingleBtn
        btnText={
          isRegister || category === 'feedback' || isReadOnly
            ? '뒤로가기'
            : '삭제하기'
        }
        hasOutline={true}
        onClick={() =>
          isRegister || category === 'feedback' || isReadOnly
            ? handleBack()
            : deleteChart({
                category,
                id,
                chartName,
                patientId,
                courseInfoId,
                chartRound,
              })
        }
      />
      {!isReadOnly &&
        (category !== 'feedback' ? (
          isRegister ? (
            <SingleBtn
              type="submit"
              btnText={`${isEdit ? '저장' : '등록'}하기`}
              isBtnActive={true}
            />
          ) : (
            <SingleBtn
              btnText="수정하기"
              isBtnActive={true}
              onClick={() => {
                navigate({
                  pathname: `${location.pathname}/register`,
                  search: location.search,
                });
              }}
            />
          )
        ) : (
          <SingleBtn
            btnText={`${isRegister ? '저장' : '수정'}하기`}
            isBtnActive={true}
          />
        ))}
      {isProfessor && !isChart && (
        <SingleBtn
          type="submit"
          btnText={`${feedbackId ? '수정' : '저장'}하기`}
          isBtnActive={true}
        />
      )}
    </div>
  );
};

export default ChartBottomBtn;
